module.exports = __webpack_public_path__ + "static/media/32-9.54b260f1.mp3";